import { FC } from "react"
import { StandardModal } from "@rhumbix/rmbx_design_system_web"
import * as API from "../../api"
import { iTimecardTemplate } from "./timecard-template-utils"

export type DeleteTimecardTemplateModalProps = {
    template: iTimecardTemplate | null
    closeMethod: () => void
    onDeleted: (templateId: number) => void
}

/**
 * Confirms and performs deletion of a saved TimecardTemplate, triggered from the delete icon
 * on a template row in the Create Timecard modal's template picker.
 */
const DeleteTimecardTemplateModal: FC<DeleteTimecardTemplateModalProps> = props => {
    const onClickDelete = () => {
        const template = props.template
        if (!template) return
        API.deleteTimecardTemplate(template.id).then(() => {
            props.onDeleted(template.id)
            props.closeMethod()
        })
    }

    return (
        <StandardModal
            id="delete-timecard-template-modal"
            autoClose={false}
            open={props.template !== null}
            closeMethod={props.closeMethod}
            title={"Delete Template"}
            description={`Are you sure you want to delete "${props.template?.name ?? ""}"? This can't be undone.`}
            primaryBtnText={"Delete Template"}
            primaryBtnOnClick={onClickDelete}
            secondaryBtnText={"Cancel"}
            secondaryBtnOnClick={props.closeMethod}
            width={"500px"}
        />
    )
}

export default DeleteTimecardTemplateModal
